export default __webpack_public_path__ + "static/media/top_right.d72c03dd.jpg";